// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins.js';
import { closeModalPageChangedMixins } from '@/app/mixins/utils/close-modal-page-changed-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Services
import auditTrailService from '@/app/services/main/audit-trail/audit-trail-service.js';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';
import { FORMAT_TEXT } from '@/app/constants/format-text-constants';

// Third party libraries
import DatePicker from 'vue2-datepicker';

export default {
    name: 'AuditTrailContainer',
    components: {
        DatePicker
    },
    mixins: [ 
        tableMixins,
        productMixins,
        closeModalPageChangedMixins,
        toastMessageMixins,
        dateMixins
    ],
    data() {
        return {
            isAPILoading: true,
            // tabs
			activeTab: 'User History',
			tabs : [
				{
					label: 'User History',
					id: 'user-history',
					active: true
				},
				{
					label: 'Pet History',
					id: 'pet-history',
					active: false
				}
            ],
            // filters
            actionList: [],
            isAuditTrailActionLoading: false,
            // table
			theads: [
				{name: 'Action', searchLabel: 'f_auditTrailAction', sortLabel: 'auditTrailAction', isDesc: false, hasActionSearch: true, style: 'min-width: 120px'},
				{ name: 'User', searchLabel: 'f_actionBy', sortLabel: 'actionBy', isDesc: false, hasSearch: true, style: null},
				{ name: 'Platform', searchLabel: 'f_platform', sortLabel: 'platform', isDesc: false, hasSearch: true, style: null},
				{ name: 'Device', searchLabel: 'f_device', sortLabel: 'device', isDesc: false, hasSearch: false, hasSearchableDropdown: true, style: null},
				{ name: 'Browser', searchLabel: 'f_browser', sortLabel: 'browser', isDesc: false, hasSearch: true, style: null},
				{ name: 'OS', searchLabel: 'f_os', sortLabel: 'os', isDesc: false, hasSearch: true, style: null},
				{ name: 'IP Address', searchLabel: 'f_ipAddress', sortLabel: 'ipAddress', isDesc: false, hasSearch: true, style: null},
				{ name: 'User Agent', searchLabel: 'f_userAgent', sortLabel: 'userAgent', isDesc: false, hasSearch: true, style: null},
                { name: 'Date and Time', searchLabel: 'f_createdAt', sortLabel: 'createdAt', isDesc: false, hasSearch: false, hasDatePicker: true, style: null},
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null}
            ],
            deviceList: ['Desktop', 'Mobile'],
            selectedDevice: '',
            selectedDateTime: '',
            activeAuditLogId: null,
            isAuditTrailChangesLoading: false,
            auditTrailChanges: {},
			// sorting
            desc: true
        }
    },
	watch: {
        selectedDevice(newVal) {
            this.getTableContent(true);
        },
        selectedDateTime(newVal) {
            this.getTableContent(true);
        }
	},
    created() {
        this.getAuditTrailActionList();
		this.getTableContent();
    },
    methods: {
        setActiveTab(activeTab) {
			this.activeTab = activeTab;
        },
        showCollapsibleRow(auditLogId) {
            if (this.activeAuditLogId === auditLogId) {
                this.activeAuditLogId = !this.activeAuditLogId ? auditLogId : null;
            } else {
                this.activeAuditLogId = auditLogId;
                this.getAuditTrailChanges(auditLogId);
            }
        },
        renderCollapsibleRow(auditLogId) {
            return auditLogId ? this.activeAuditLogId === auditLogId : false;
        },
        updateActionDisplay(action, noUnderScore) {
            return noUnderScore ? action.replace(/_/g, ' ') : action.replace(/ /g, '_');
        },
        camelCaseToUpperCase(text) {
            return text.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
        },
        convertToCapitalizeCase(text) {
            if(!text) return text
            
            return text
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
        formatText(text) {
            return FORMAT_TEXT[text] ? FORMAT_TEXT[text] : text;
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
			this.getAuditTrailList({ page, limit, sortBy, desc });
		},
        getAuditTrailActionList() {
            this.isAuditTrailActionLoading = true;

            auditTrailService.getAuditTrailActionList()
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.actionList = res.data;
                        this.actionList.forEach((action, index) => {
                            this.actionList[index] = this.updateActionDisplay(action, true);
                        });
                    } else {
                        const { ERROR_GET_AUDIT_TRAIL_ACTION } = this.toastMessages.auditTrail();
						this.showAPIErrorToast(ERROR_GET_AUDIT_TRAIL_ACTION, res);
                    }
                    this.isAuditTrailActionLoading = false;
                });
        },
        getAuditTrailChanges(auditTrailId) {
            this.isAuditTrailChangesLoading = true;

            auditTrailService.getAuditTrailChanges(auditTrailId)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.auditTrailChanges = res.data;
                    } else {
                        const { ERROR_GET_AUDIT_TRAIL_CHANGES } = this.toastMessages.auditTrail();
						this.showAPIErrorToast(ERROR_GET_AUDIT_TRAIL_CHANGES, res);
                    }
                    this.isAuditTrailChangesLoading = false;
                });
        },
		getAuditTrailList(queryParams) {
			// Append Device filter
			if (this.selectedDevice) {
				queryParams['f_device'] = this.selectedDevice.toLowerCase();
			}
            
			// Append Device filter
			if (this.selectedDateTime) {
				queryParams['f_createdAt'] = this.formatDate(this.selectedDateTime, 'yyyy-MM-dd HH:mm');
			}

			// Search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_actionBy) {
					queryParams['f_actionBy'] = this.columnsFilter.f_actionBy; 
				}
				if (this.columnsFilter.f_platform) {
					queryParams['f_platform'] = this.columnsFilter.f_platform;
				}
				if (this.columnsFilter.f_browser) {
					queryParams['f_browser'] = this.columnsFilter.f_browser; 
				}
				if (this.columnsFilter.f_os) {
					queryParams['f_os'] = this.columnsFilter.f_os; 
				}
				if (this.columnsFilter.f_ipAddress) {
					queryParams['f_ipAddress'] = this.columnsFilter.f_ipAddress; 
				}
				if (this.columnsFilter.f_userAgent) {
					queryParams['f_userAgent'] = this.columnsFilter.f_userAgent; 
				}
                if (this.columnsFilter.f_auditTrailAction) {
                    queryParams['f_auditTrailAction'] = this.updateActionDisplay(this.columnsFilter.f_auditTrailAction);
                }
			}

			this.isAPILoading = true;

			auditTrailService.getAuditTrailList(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
                        };
                        
                        // add show property for collapsible
                        for (let row of this.tableContent.tableData) {
                            row.show = false;
                        }
					} else {
                        const { ERROR_GET_AUDIT_TRAIL_LIST } = this.toastMessages.auditTrail();
						this.showAPIErrorToast(ERROR_GET_AUDIT_TRAIL_LIST, res);
					}
                    this.isAPILoading = false;
				});
		}
    }
}
